module.exports = __webpack_public_path__ + "static/media/ask.2ef67d70.svg";